// extracted by mini-css-extract-plugin
export default {"imageWrapper":"BE-z","hovered":"CE-z","hoverImage":"DE-z","mainImage":"EE-z","imageNoBackground":"FE-z","fullSizeImage":"GE-z"};